function RecordFilter() {
  return filter;
  
  /**
  * Start at a specific index
  *
  * @param {Array} records 
  * @param {Array} filters { key: "key", evaluate: function(value, index, record) })
  * @return {Array} filtered records
  */
  function filter(records, filters) {

    if (!records || !records.length || !filters || !filters.length) { return records }
    
    return records.filter( rec => {
      return filters.reduce( (acc, filt, idx) => {
        return acc || filt.evaluate( rec[filt.key], idx, rec );
      }, false);
    });

  }
}

export default RecordFilter;
